import { WordDictionary } from '@/types/wordDictionary';
import apiClient from '@/utils/api';

const dictionaryAdminBaseUrl = '/admin/dictionary';

export const dictionaryAdminApi = {
  getAll: async (params?: {
    search?: string;
    filterType?: 'all' | 'unreviewed';
    limit?: number;
    cursor?: string;
  }) => {
    const response = await apiClient.get(`${dictionaryAdminBaseUrl}`, { params });
    return response.data;
  },

  getByWord: async (word: string) => {
    const response = await apiClient.get(`${dictionaryAdminBaseUrl}/${encodeURIComponent(word)}`);
    return response.data;
  },

  searchAndGenerate: async (word: string) => {
    const response = await apiClient.get('/dictionary/search', {
      params: { word },
    });
    return response.data;
  },

  deleteFixedPhrase: async (phrase: string) => {
    const response = await apiClient.post(`${dictionaryAdminBaseUrl}/fixed-phrases/delete`, {
      phrase,
    });
    return response.data;
  },

  update: async (word: string, entry: Partial<WordDictionary>) => {
    const response = await apiClient.put(
      `${dictionaryAdminBaseUrl}/${encodeURIComponent(word)}`,
      entry
    );
    return response.data;
  },

  approve: async (words: string[]) => {
    const response = await apiClient.post(`${dictionaryAdminBaseUrl}/approve`, { words });
    return response.data;
  },

  regenerateDictionary: async (word: string) => {
    const response = await apiClient.post(
      `${dictionaryAdminBaseUrl}/${encodeURIComponent(word)}/regenerate`
    );
    return response.data;
  },

  regenerateAudio: async (
    word: string,
    variant: 'UK' | 'US',
    options?: { partOfSpeech?: string | null; ipa?: string }
  ) => {
    const response = await apiClient.post(
      `${dictionaryAdminBaseUrl}/${encodeURIComponent(word)}/audio/regenerate`,
      {
        variant,
        partOfSpeech: options?.partOfSpeech,
        ipa: options?.ipa,
      }
    );

    return response.data;
  },
  uploadAudio: async (
    word: string,
    variant: 'UK' | 'US',
    audioBase64: string,
    partOfSpeech?: string | null
  ) => {
    const response = await apiClient.post(
      `${dictionaryAdminBaseUrl}/${encodeURIComponent(word)}/audio/update`,
      { variant, partOfSpeech, audioBase64 }
    );

    return response.data;
  },
  deleteAudio: async (word: string, variant: 'UK' | 'US', partOfSpeech?: string | null) => {
    const response = await apiClient.post(
      `${dictionaryAdminBaseUrl}/${encodeURIComponent(word)}/audio/delete`,
      { variant, partOfSpeech }
    );

    return response.data;
  },
};
